import { type SupportedLocale, toSupportedLocale } from "@offstreetparking/domain/i18n";
import { i18nConfig } from "../../../i18n-config";

export const localizedPath = ({ pathname, locale }: { pathname: string; locale: SupportedLocale }) => {
	const [, firstSegment, ...rest] = pathname.split("/");
	const segments = toSupportedLocale(firstSegment) ? rest : [firstSegment, ...rest];
	const path = segments.join("/");

	if (locale === i18nConfig.defaultLocale) {
		return `/${path}`;
	}
	return path ? `/${locale}/${path}` : `/${locale}`;
};
